
import React, {Component, createRef, useState} from "react";
// import image1 from '../../img/series/1.jpg'
// import image2 from './../../img/series/2.jpg'
// import image3 from './../../img/series/3.jpg'
// import image4 from './../../img/series/4.jpg'
// import image5 from './../../img/series/5.jpg'
// import image6 from './../../img/series/6.jpg'
// import image7 from './../../img/series/7.jpg'
// import image8 from './../../img/series/8.jpg'
// import image9 from './../../img/series/9.jpg'
// import image10 from './../../img/series/10.jpg'
// import image11 from './../../img/series/11.jpg'
// import image12 from './../../img/series/12.jpg'




import videoPlaceHolder from "./imagePlaceholder.jpeg";
import './Videoplayer.css';
import {
    Playlist,
    goToNextVideo,
    goToPreviousVideo
} from "reactjs-video-playlist-player";

function Video() {
    const [videoList, setVideoList] = useState([
        {
            thumbnail: 'https://i.imgur.com/wPFhZAo.jpg',
            url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
            imgAlt: "1 серія"
        },
        {
            thumbnail: 'https://i.imgur.com/dLSWYj4.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
            imgAlt: "Image 2 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/zPOew1M.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
            imgAlt: "Image 3 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/KTrzW1o.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
            imgAlt: "Image 4 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/kbeLlLC.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/3YRKwe1.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/hMCc7kZ.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/Kiir6Cx.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/assxL90.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/iWTtclK.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/G6MJj7I.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        },
        {
            thumbnail: 'https://i.imgur.com/14hkvPG.jpg',
            url:
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            imgAlt: "Image 5 not found"
        }
    ]);

    const [currentVideo, setCurrentVideo] = useState(0);
    const vidRef = createRef(null);

    const params = {
        videos: videoList,
        autoPlay: true,
        showQueue: true,
        playForward: true,
        defaultQueueItemPlaceholderThumbnail: videoPlaceHolder,
        currentVideo: currentVideo,
        setCurrentVideo: setCurrentVideo,
        vidRef: vidRef
    };

    return (
        <div className="Video" id='videoComponent'>

            <div >
                <Playlist playlistParams={params} />
            </div>
        </div>
    );
}

export default Video;
